import { FetchModelResponse } from '@cian/http-api';
import { IV1GetClustersForMapResponseSchema } from 'shared/common/repositories/search-offers-index/entities/get_clusters_for_map/V1GetClustersForMapResponseSchema';
import { IErrorResponseSchema } from 'shared/common/repositories/search-offers-index/entities/schemas/ErrorResponseSchema';

export const mapFetchClustersResponse = (
  response: IV1GetClustersForMapResponseSchema,
): FetchModelResponse<200, 'json', IV1GetClustersForMapResponseSchema> => {
  return {
    statusCode: 200,
    response,
  };
};

export const mapFetchClustersResponseError = (
  response: IErrorResponseSchema,
): FetchModelResponse<400, 'json', IErrorResponseSchema> => {
  return {
    statusCode: 400,
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
